window.config = {
    isOnAzureCloud: true,
    authMethod: 'OAUTH',
    servicenameSubstitution: {},
    configURL: {
        baseURL: 'https://atse-ngd-core1.lisec.internal:7441/',
    },
    dataDogConfig: {
        applicationId: '9c0f304b-85a4-499d-81de-3f1316732617',
        clientToken: 'pub4a8f6680b86c80745409f5cad2e90372',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.eu',
        service: 'customer-management',
        env: 'dev',
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        flushTimeout: 60000,
        allowedTracingUrls: [/https:\/\/.*\.lisec\.io/, /https:\/\/.*\.lisec\.internal/]
    }
};
